import { handleActions } from "redux-actions";
import * as orderCardActions from "../actions/orderCard";

let initState = {
  isLoading: false,
  errorMessage: "",
  surchargePaymentData: null,
  assignDriverDrawerIsVisible: false
};

export const orderCard = handleActions(
  {
    //Get Order Id
    [orderCardActions.getOrderById]: state => {
      return { ...state, isLoading: true };
    },
    [orderCardActions.getOrderByIdSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        data: payload,
        isLoading: false
      };
    },
    [orderCardActions.getOrderByIdError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false
      };
    },
    // Create Order
    [orderCardActions.createOrder]: state => {
      return { ...state, isLoading: true };
    },
    [orderCardActions.createOrderSuccess]: (state, action) => {
      return {
        ...state,
        isLoading: false
      };
    },
    [orderCardActions.createOrderError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        createErrors: payload,
        isLoading: false
      };
    },
    [orderCardActions.createOrderClearError]: (state, action) => {
      let { payload } = action;
      let newState = { ...state };
      if (payload) {
        if (
          newState.createErrors &&
          newState.createErrors.data &&
          newState.createErrors.data[payload]
        ) {
          delete newState.createErrors.data[payload];
          if (Object.keys(newState.createErrors.data).length === 0) {
            newState.createErrors = null;
          }
          newState.createErrors = { ...newState.createErrors };
        }
      } else {
        if (newState.createErrors) {
          newState.createErrors = null;
        }
      }
      return newState;
    },
    // Update Order
    [orderCardActions.updateOrder]: state => {
      return { ...state, isLoading: true };
    },
    [orderCardActions.updateOrderSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        create: payload,
        isLoading: false
      };
    },
    [orderCardActions.updateOrderError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        updateErrors: payload,
        isLoading: false
      };
    },

    // ДОПЛАТЫ ПО ЗАКАЗУ
    [orderCardActions.getSurchargePaymentData]: state => {
      return { ...state, surchargePaymentIsLoading: true };
    },
    [orderCardActions.getSurchargePaymentDataSuccess]: (state, action) => {
      return {
        ...state,
        surchargePaymentIsLoading: false,
        surchargePaymentData: action.payload
      };
    },
    [orderCardActions.getSurchargePaymentDataFailure]: (
      state,
      { payload: { message, errors } }
    ) => {
      return { ...state, errorMessage: message, errors };
    },

    [orderCardActions.getOrderReport]: state => {
      return { ...state, orderReportIsLoading: true };
    },
    [orderCardActions.getOrderReportSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        orderReport: payload.map((item, index) => ({ key: index, ...item })),
        orderReportIsLoading: false
      };
    },
    [orderCardActions.getOrderReportError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        orderReportErrors: payload,
        orderReportIsLoading: false
      };
    },
    [orderCardActions.downloadContractByOrderId]: state => {
      return { ...state, downloadIsLoading: true };
    },
    [orderCardActions.downloadContractByOrderIdSuccess]: (state, action) => {
      // let { payload } = action;
      return {
        ...state,
        downloadIsLoading: false
      };
    },
    [orderCardActions.downloadContractByOrderIdError]: (state, action) => {
      // let { payload } = action;
      return {
        ...state,
        err: "Ошибка",
        downloadIsLoading: false
      };
    },
    [orderCardActions.downloadNotificationToGibdd]: state => {
      return { ...state, downloadNotificationIsLoading: true };
    },
    [orderCardActions.downloadNotificationToGibddSuccess]: state => {
      return {
        ...state,
        downloadNotificationIsLoading: false
      };
    },
    [orderCardActions.downloadNotificationToGibddError]: state => {
      return {
        ...state,
        err: "Ошибка",
        downloadNotificationIsLoading: false
      };
    },
    //  archieve Order
    [orderCardActions.archieveOrder]: (state, action) => {
      return {
        ...state,
        isLoading: true
      };
    },
    [orderCardActions.setAssignDriverDrawerVisibility]: (state, action) => {
      return {
        ...state,
        assignDriverDrawerIsVisible: action.payload
      };
    },
    [orderCardActions.assignDriver]: (state, action) => {
      return {
        ...state
      };
    },
    [orderCardActions.assignDriverSuccess]: (state, action) => {
      return {
        ...state
      };
    },
    [orderCardActions.assignDriverFailure]: (state, action) => {
      return {
        ...state
      };
    }
  },
  initState
);
